<div class="product">
  <div class="image">
    <img [src]="product.imageUrl" (error)="product.imageUrl= 'assets/images/product_img_dummy.png'" />
    <div class="attributes">
      <div *ngFor="let attribute of product.warranties | productAttributeSort">
        <img src="{{attribute | productAttribute}}" />
      </div>
    </div>
  </div>
  <div class="content">
    <div class="informations">
      <div class="name">{{product.productModel || 'Produktbezeichnung fehlt'}}</div>
      <div class="manufacturer">{{product.manufacturerName}} / {{isBrotherProduct ?
        consts.productCategoryMap[product.productCategory.toLowerCase()] : product.productTypeName}}</div>
      <div class="features">
        <div *ngFor="let feature of product.keyFeatures | keyFeatureFilter: 3" class="feature">
          <i class="icon fa fa-plus"></i>
          {{feature}}
        </div>
      </div>
    </div>
    <div *ngIf="isBrotherProduct && !bookmarkMode" class="buttons">
      <button (click)="showDetails()" class="product-details">Produktdetails</button>
      <button (click)="folderService.open(product.manufacturerSKU)" class="favorite">In die Merkliste</button>
    </div>
    <div *ngIf="!isBrotherProduct && !bookmarkMode && !blocked()" class="buttons">
      <button (click)="findAlternatives()" class="find-alternative-products">Vergleichsprodukte finden</button>
    </div>
    <div *ngIf="bookmarkMode" class="buttons">
      <button (click)="showDetails()" class="product-details">Produktdetails</button>
      <button (click)="deleteProductFromFolder.emit()" class="remove-from-bookmarks"><i class="fa fa-trash"></i>
        Entfernen</button>
    </div>
  </div>
</div>
